// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nc-0";